import React from "react";

import "./BranchDetails.scss";
import AccountCircle from "@material-ui/icons/AccountCircle";

const BranchDetails = (props: any) => {
  if (!props.branch) {
    return null;
  }
  return (
    <div className="BranchDetails-container">
      <div className="BranchDetails-branchDetails">
        <div className="BranchDetails-branchDetailsContainer">
          <div>
            <b className="BranchDetails-infoLabel">Name:</b>{" "}
            <b className="BranchDetails-branchDetailsName BranchDetails-infoItem">
              {props.branch.name}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">Contact Name:</b>{" "}
            <b className="BranchDetails-branchDetailsContactName BranchDetails-infoItem">
              {props.branch.contactName}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">Street Address:</b>{" "}
            <b className="BranchDetails-branchDetailsStreetAddress BranchDetails-infoItem">
              {props.branch.streetAddress}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">City:</b>{" "}
            <b className="BranchDetails-branchDetailsCity BranchDetails-infoItem">
              {props.branch.city}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">County:</b>{" "}
            <b className="BranchDetails-branchDetailsCounty BranchDetails-infoItem">
              {props.branch.county}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">Postcode:</b>{" "}
            <b className="BranchDetails-branchDetailsPostcode BranchDetails-infoItem">
              {props.branch.postcode}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">Intrafin ID:</b>{" "}
            <b className="BranchDetails-branchDetailsIntrafinId BranchDetails-infoItem">
              {props.branch.intrafinId}
            </b>
          </div>
          <div>
            <b className="BranchDetails-deliveryMethod">Delivery Method:</b>{" "}
            <b className="BranchDetails-branchDetailsDeliveryMethod BranchDetails-infoItem">
              {props.branch.deliveryMethod === 0
                ? "None"
                : props.branch.deliveryMethod === 1
                ? "RMS Van 1"
                : props.branch.deliveryMethod === 2
                ? "RMS Van 2"
                : props.branch.deliveryMethod === 3
                ? "G4S Trunking"
                : props.branch.deliveryMethod === 4
                ? "Registered Mail"
                : "G4S Van"}
            </b>
          </div>
          <div>
            <b className="BranchDetails-dealType">Selling Deal Type:</b>{" "}
            <b className="BranchDetails-branchDetailsDealType BranchDetails-infoItem">
              {props.branch.sellingDealType === 0
                ? "None"
                : props.branch.sellingDealType === 1
                ? "BNDSL"
                : "DOROP"}
            </b>
          </div>
          <div>
            <b className="BranchDetails-buyingDealType">Buying Deal Type:</b>{" "}
            <b className="BranchDetails-branchDetailsBuyingDealType BranchDetails-infoItem">
              {props.branch.buyingDealType === 2
                ? "BNDBY"
                : props.branch.buyingDealType === 1
                ? "PODOC"
                : "None"}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">
              Order Value Date Modifier:
            </b>{" "}
            <b className="BranchDetails-branchDetailsValueDateModifier BranchDetails-infoItem">
              {props.branch.valueDateModifier}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">
              Order Despatch Date Modifier:
            </b>{" "}
            <b className="BranchDetails-branchDetailsDespatchDateModifier BranchDetails-infoItem">
              {props.branch.despatchDateModifier}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">
              Return Value Date Modifier:
            </b>{" "}
            <b className="BranchDetails-branchReturnDetailsValueDateModifier BranchDetails-infoItem">
              {props.branch.returnValueDateModifier}
            </b>
          </div>
          <div>
            <b className="BranchDetails-infoLabel">
              Order Despatch Date Modifier:
            </b>{" "}
            <b className="BranchDetails-branchDetailsReturnDespatchDateModifier BranchDetails-infoItem">
              {props.branch.returnDespatchDateModifier}
            </b>
          </div>
        </div>
      </div>
      {props.showPeople && (
        <div className="BranchDetails-tableContainer">
          <div className="BranchDetails-infoLabel BranchesTable-tableTitle">
            Users:
          </div>
          <table className="BranchesTable-container">
            <thead className="BranchesTable--headPanel">
              <tr className="BranchesTable--headPanelRow">
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email Address</th>
                <th>Order Limit</th>
                <th>Daily Limit</th>
              </tr>
            </thead>
            <tbody>
              {props.branch.customers &&
                props.branch.customers.map((customer: any) => (
                  <tr
                    className="BranchesTable--row"
                    key={`branchCustomer-${customer.id}`}
                  >
                    <td>{customer.firstName}</td>
                    <td>{customer.lastName}</td>
                    <td>{customer.email}</td>
                    <td>{customer.orderLimit}</td>
                    <td>{customer.dailyLimit}</td>
                  </tr>
                ))}
            </tbody>
          </table>

          {props.branch &&
          props.branch.customers &&
          props.branch.customers.length === 0 ? (
            <div className="CompaniesTable--noDataContainer">
              <AccountCircle className="CompaniesTable--noDataIcon" />
              <p className="CompaniesTable--noDataText">
                There are currently no users to display for this branch.
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default BranchDetails;
